/**
 * Guarda Mundo - preview_mode gate
 * Persiste ?preview_mode=true em links internos após primeira visita autorizada.
 */
(function () {
  const STORAGE_KEY = 'gm_preview_mode';
  const PARAM = 'preview_mode';
  const PARAM_VALUE = 'true';

  function isPreviewActive() {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === PARAM_VALUE;
    } catch {
      return false;
    }
  }

  function withPreviewParam(url) {
    if (!url.searchParams.has(PARAM)) {
      url.searchParams.set(PARAM, PARAM_VALUE);
    }
    return url.pathname + url.search + url.hash;
  }

  function augmentInternalLinks(root) {
    if (!isPreviewActive()) return;

    root.querySelectorAll('a[href]').forEach((anchor) => {
      const rawHref = anchor.getAttribute('href');
      if (!rawHref || rawHref.startsWith('#') || rawHref.startsWith('mailto:') || rawHref.startsWith('tel:'))
        return;

      try {
        const url = new URL(rawHref, window.location.origin);
        if (url.origin !== window.location.origin) return;
        anchor.setAttribute('href', withPreviewParam(url));
      } catch {
        /* ignore malformed href */
      }
    });
  }

  function init() {
    const params = new URLSearchParams(window.location.search);
    if (params.get(PARAM) === PARAM_VALUE) {
      try {
        sessionStorage.setItem(STORAGE_KEY, PARAM_VALUE);
      } catch {
        /* ignore */
      }
    }

    augmentInternalLinks(document);

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) return;
          if (node.matches('a[href]')) augmentInternalLinks(node.parentElement || document);
          else augmentInternalLinks(node);
        });
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
